import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import IconShieldAlert from "./shield-alert.svg";

export const Container = styled.div`
  display: flex;
  align-items: center;

  inline-size: 620px;
  block-size: 48px;
  padding: 12px;

  color: #999999;

  border: 1px solid #999999;
`;

export const StyledIconShieldAlert = styled(IconShieldAlert)`
  inline-size: 24px;
  block-size: 24px;
  margin-inline-end: 8px;
`;

export const Text = styled.span`
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;
